/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGetInfluencerQuery } from './../../../generated/graphql';
import { useUserStore } from '../stores/user.store';
import { useCustomizations } from './use-customizations';
import { MediaCover } from '../../components/collections/collections.types';
import * as enums from '@playbook-technologies/common-enums';

export type GA4Configuration = {
  measurementId: string;
  apiSecret?: string;
};

export type TikTokConfiguration = {
  pixelId?: string;
  apiSecret?: string;
};
export type RawUser = {
  id: number; // not influencerId
  influencerId: number;
  campaignFirstLogin: number;
  username: string;
  role: number;
  firstName: string;
  lastName: string;
  email: string;
  token: string;
  tokenExpiresAt: string;
  influencer: {
    id: number; // influencerId;
    type: number;
    firstName: string;
    lastName: string;
    tags: Array<unknown>;
    profileDeepLink: string;
    mediaCover: MediaCover | null;
    isPaymentEnabled: boolean;
    paymentMethod: number | null;
    stripeUserId: number | null;
    paypal: string | null;
    salesModel: 'one-time-purchase' | 'subscription' | 'both';

    bio: string | null;
    communityId: string | null;
    customURL: string;
    customizations: Record<any, any>;
    isVisible: boolean;
    latestWorkout: null;
    liveStreamKey: null;
    mediaAvatar: MediaCover | null;

    mode: number;
    profileInstagram?: string | null;
    publishedAt: null;
    tier: number;
    title: string;

    facebookPixelId: string | null;
    facebookConversionApiAccessToken: string | null;
    ga4Configuration: GA4Configuration | null;
    tikTokConfiguration: TikTokConfiguration | null;
    collectionType: string;
    productType: string;
    publisheCollectionsCount: number;
    publishedWorkoutsCount: number;
    visibility: string;
    subscriptionMonthlyPrice?: number;
    subscriptionAnnualPrice?: number;
  };
};

type RoleLite = 'admin' | 'moderator' | 'user';

export const getRoleLite = (role: number): RoleLite => {
  switch (role) {
    case enums.PortalUser.Role.Administrator.value:
      return 'admin';
    case enums.PortalUser.Role.Moderator.value:
      return 'moderator';
    default:
      return 'user';
  }
};

export const useUser = (id?: number) => {
  const { user, login, logout } = useUserStore();
  const influencerId = user?.influencerId || id;
  const influencerQuery = useGetInfluencerQuery({
    variables: { id: influencerId },
    // fetchPolicy: 'no-cache',
    skip: !influencerId,
  });
  const customizations = useCustomizations(influencerId);
  const influencer = influencerQuery.data?.creator ?? null;
  const isAdmin = () => user.role === enums.PortalUser.Role.Administrator.value;
  const isAuthenticated = !!user;

  return {
    influencerQuery,
    called: influencerQuery.called,
    isLoading: influencerQuery.loading || customizations.isLoading,
    isAuthenticated: !!user,
    user: { ...user, influencer } as RawUser,
    influencer,
    roleLite: isAuthenticated ? getRoleLite(user.role) : null,
    login,
    isAdmin,
    logout,
    refetchInfluencer: influencerQuery.refetch,
    customizations: customizations.customizations,
    loading: influencerQuery.loading,
  };
};

export const parseId = (influencerId?: string) => {
  if (influencerId === undefined) return null;
  const id = parseInt(influencerId, 10);
  if (Number.isNaN(id)) return null;
  return id;
};
